export interface APIException {
	type?: string
	status?: number
	title?: string
	detail?: string
	instance?: string
}

export function isAPIException(error: unknown): error is APIException {
	return typeof error === 'object' && error !== null && ('title' in error || 'detail' in error)
}
